// @ts-nocheck

export type AdminTemplatesListCategory =
  typeof AdminTemplatesListCategory[keyof typeof AdminTemplatesListCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminTemplatesListCategory = {
  adventure: "adventure",
  bedtime: "bedtime",
  custom: "custom",
  educational: "educational",
  family: "family",
  fantasy: "fantasy",
  friendship: "friendship",
  seasonal: "seasonal",
} as const;
